import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials = [{
  name: 'Laura Giménez',
  city: 'Buenos Aires',
  text: 'Nunca creí que caminar pudiera cambiar tanto mi cuerpo. En 6 semanas bajé 5 kilos y lo mejor es que no siento que hice ningún sacrificio enorme. El programa es clarísimo y muy fácil de seguir.'
}, {
  name: 'Martín Rodríguez',
  city: 'Rosario',
  text: 'Lo que más me cambió fue el módulo de frecuencia cardíaca. Antes caminaba sin método y no quemaba nada. Ahora en 40 minutos hago lo que antes no lograba en 2 horas de gimnasio.'
}, {
  name: 'Sofía Herrera',
  city: 'Mendoza',
  text: 'Soy mamá de dos nenas y trabajo todo el día. Pensé que nunca tendría tiempo. Este programa me demostró que con 30 minutos bien usados es suficiente. ¡Bajé 7 kilos en 2 meses!'
}, {
  name: 'Carlos Vega',
  city: 'Córdoba',
  text: 'Tenía mucho miedo de lastimarme con ejercicios intensos. Acá empecé de a poco, a mi ritmo, y hoy me siento con una energía que no tenía hace años. El conocimiento de los módulos es oro puro.'
}];
export function Testimonials() {
  return <section className="w-full bg-white" data-id="element-180" data-mp="m2oor20ic8p1">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-24" data-id="element-181" data-mp="78tv338xapyf">
        <Reveal className="text-center" data-id="element-182" data-mp="c6ve5o6cmp9w">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-183" data-mp="c7wry0er1pvb">
            Esto dicen quienes ya lo hicieron
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-184" data-mp="14vj0zo6qxmpk">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i % 2 * 0.08} data-id="element-185" data-mp="q765esbkm5vl" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl border border-ink/10 bg-cream p-7 shadow-sm" data-id="element-186" data-mp="q4jy8tsldsdw">
                <div className="flex gap-0.5 text-amber-400" data-id="element-187" data-mp="v3d17sa960zt">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-amber-400" data-id="element-188" data-mp="1nlqsta4zwqqg" data-mpi={s} />)}
                </div>
                <p className="mt-4 flex-1 text-base leading-relaxed text-ink/80" data-id="element-189" data-mp="1xi93pc4qjjel">"{t.text}"</p>
                <p className="mt-5 text-sm font-bold text-ink" data-id="element-190" data-mp="1sio20ty6kwy6">
                  {t.name} <span className="font-medium text-ink/50" data-id="element-191" data-mp="1ohaumfffwlp5">— {t.city}</span>
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}